export default __webpack_public_path__ + "static/media/back.1497ca3f.svg";